// // Need to use the React-specific entry point to import createApi
// import { UnidadDeMedida } from "../types"
// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
// const serverUrl = process.env.REACT_APP_SERVER_URL

// // Define a service using a base URL and expected endpoints
// export const uomApi = createApi({
//   reducerPath: "uomApi",
//   baseQuery: fetchBaseQuery({ baseUrl: `${serverUrl}/api/products/` }),
//   endpoints: builder => ({
//     getUoMById: builder.query<UnidadDeMedida,number>({
//       query: id => `uom/${id}`,
//     }),
//   }),
// })

// // Export hooks for usage in functional components, which are
// // auto-generated based on the defined endpoints
// export const { useGetUoMByIdQuery } = uomApi

// --fiautom1_products.unit_of_measure definition

// CREATE TABLE`unit_of_measure`(
//   `id` int(11) NOT NULL AUTO_INCREMENT,
//   `key` varchar(100) DEFAULT NULL,
//   `name` varchar(100) DEFAULT NULL,
//   `equivalence` int(11) DEFAULT NULL,
//   `factor` float DEFAULT NULL,
//   PRIMARY KEY(`id`),
//   KEY`unit_of_measure_FK`(`equivalence`),
//   CONSTRAINT`unit_of_measure_FK` FOREIGN KEY(`equivalence`) REFERENCES`unit_of_measure`(`id`)
// ) ENGINE = InnoDB AUTO_INCREMENT = 22 DEFAULT CHARSET = utf8mb4 COMMENT = 'Unidades de medida';

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { FileStatType } from '../types'
export type UnitOfMeasure = {
  id: number
  key: string
  name: string
  equivalence: number | undefined
  factor: number | undefined
}
export type IdName = {
  id: number
  name: string
}

export type UnitsOfMeasureResponse = UnitOfMeasure[] | IdName[]


//const serverUrl = process.env.REACT_APP_SERVER_URL
const serverUrl = "http://localhost:6060"

export const fiammapi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: `${serverUrl}/api/` }),
  tagTypes: ["UnitOfMeasure"],
  endpoints: builder => ({
    getUnitsOfMeasure: builder.query<UnitsOfMeasureResponse, void>({
      query: () => "products/unit-of-measure",
      providesTags: result =>
        result
          ? [...result.map(({ id }) => ({ type: "UnitOfMeasure" as const, id })), { type: "UnitOfMeasure", id: "LIST" }]
          : [{ type: "UnitOfMeasure", id: "LIST" }],
    }),
    getBasicUnits: builder.query<UnitsOfMeasureResponse, void>({
      query: () => "products/basicunits",
    }),
    getMLCacheStat: builder.query<FileStatType, void>({
      query: () => "mercadolibre/cache/age",
    }),
    addUnitOfMeasure: builder.mutation<UnitOfMeasure, Partial<UnitOfMeasure>>({
      query: body => ({
        url: `products/unit-of-measure`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "UnitOfMeasure", id: "LIST" }],
    }),
    getUnitOfMeasure: builder.query<UnitOfMeasure, string>({
      query: id => `products/unit-of-measure/${id}`,
      providesTags: (result, error, id) => [{ type: "UnitOfMeasure", id }],
    }),
    updateUnitOfMeasure: builder.mutation<void, Pick<UnitOfMeasure, "id"> & Partial<UnitOfMeasure>>({
      query: ({ id, ...patch }) => ({
        url: `products/unit-of-measure/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "UnitOfMeasure", id }],
    }),
    deleteUnitOfMeasure: builder.mutation<{ success: boolean; id: number }, number>({
      query(id) {
        return {
          url: `products/unit-of-measure/${id}`,
          method: "DELETE",
        }
      },
      invalidatesTags: (result, error, id) => [{ type: "UnitOfMeasure", id }],
    }),
  }),
})

export const {
  useGetMLCacheStatQuery,
  useGetUnitOfMeasureQuery,
  useGetBasicUnitsQuery,
  useGetUnitsOfMeasureQuery,
  useAddUnitOfMeasureMutation,
  useUpdateUnitOfMeasureMutation,
  useDeleteUnitOfMeasureMutation,
} = fiammapi
